// extracted by mini-css-extract-plugin
export default {"questionContainer":"styles_questionContainer__yKGOa","pdfDocument":"styles_pdfDocument__j2PBJ","footerStyles":"styles_footerStyles__2QHmE"};